import {CustomSelectAndChildren} from '../../../../components/CustomSelectAndChildren';
import React from 'react';
import {CustomDatePicker} from '../../../../components/CustomDatePicker';
import {MenuItem} from '@mui/material';
import {useSelector} from 'react-redux';
import CustomSearch from '../../../../components/SearchSimples/CustomSearch';
import SearchSimple from "../../../../components/SearchSimples/SearchSimple";
import {TABS_KITCHEN, today, yesterday} from "../Model/Models";
/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param model item: model of header section
 * @param event handleChange: Event to update the module in the header section
 * @param useState search: Variable for searching the items
 * @param useState setSearch: State to update the search variable for items
 *
 */
const KitchenHeader = (
    {
        item,
        handleChange,
        search,
        setSearch,
        activeStep,
        searchId,
        setBodyForExport,
        setResults,
        option,
        rowsPerPage,
        setSimpleSearch,
        getData
    }
) => {

    const { allCafeterias } = useSelector(state => state.FoodieShiftSlice);

    const onReset = () => {
        setSearch("");
    }

    return (<div className='row'>
        <div className='col-3'>
            <CustomSelectAndChildren
                id='slt_kh_diner_select_id'
                name='cafeteria'
                trans='select_a_diner'
                value={item?.cafeteria?.id || ''}
                required={true}
                onChange={(e)=> {
                    const selected = allCafeterias.find(item => item?.id === e?.target?.value);
                    handleChange({ target: { name: e?.target?.name, value: selected } })
                }}
                showNoSelectionOption={false}
            >
                {allCafeterias?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                        {item.name}
                    </MenuItem>
                ))}
            </CustomSelectAndChildren>
        </div>
        <div className='col-3'>
            <CustomDatePicker
                id={'dp_kh_date_filter'}
                name={'date'}
                disabled={false}
                trans={'cafeteria_serving_date'}
                value={item.date}
                required={true}
                minDate={activeStep === TABS_KITCHEN.ORDERS.INDEX  ? yesterday : undefined }
                maxDate={today}
                openTo={'day'}
                onChange={(e) => {
                    handleChange({ target: { value: e, name: 'date' } });
                }}
            />
        </div>
        <div className='col-6'>
            { activeStep === TABS_KITCHEN.ORDERS.INDEX  ?
                <CustomSearch id={'txt_kh_search'}
                              label={"search_by_name"}
                              value={search}
                              setValue={setSearch}
                              onChange={(e) => setSearch(e.target.value)}
                              onReset={()=>onReset()}
                />
                :
                <SearchSimple
                    id={searchId}
                    setBodyForExport={setBodyForExport}
                    setSearchResults={setResults}
                    searchElement={search}
                    setSearchElement={setSearch}
                    optionTable={option}
                    rowsPerPage={rowsPerPage}
                    setSimpleSearch={setSimpleSearch}
                    search={search}
                    setSearch={setSearch}
                    contractorId={null}
                    supplierId={null}
                    callApi={() => getData(0, {searchElement: search})}
                    resetApi={() => getData(0, {searchElement: ''})}
                />
            }
        </div>
    </div>)

}

export default KitchenHeader
